export default __webpack_public_path__ + "static/media/baby-22.5d3f8a97.svg";